<template>
    <div class="content">
        <div class="row animated fadeIn">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Support Tasks</h4>
                        <ul class="nav nav-tabs" id="myTab" role="tablist">

                            <li class="nav-item">
                                <a class="nav-link active show" id="active-tab"
                                   data-toggle="tab" href="#activeTasks" role="tab" aria-controls="up" @click="changeTabs('urgent')">
                                  Urgent
                                  <span class="badge badge-danger rounded-circle noti-icon-badge ml-2">{{activeSupportTasks.newUrgent}}</span>
                                </a>
                            </li>
<!--                          <li class="nav-item">-->
<!--                                <a class="nav-link" id="mv-tab"-->
<!--                                   data-toggle="tab" href="#mediavineIntegration" role="tab" aria-controls="up" @click="changeTabs('mvIntegration')">-->
<!--                                  MV Integration-->
<!--                                  <span class="badge badge-danger rounded-circle noti-icon-badge ml-2">{{activeSupportTasks.mediavine}}</span>-->
<!--                                </a>-->
<!--                            </li>-->
                            <li class="nav-item">
                                <a class="nav-link" id="backup-tab"
                                   data-toggle="tab" href="#backupTasks" role="tab" aria-controls="up" @click="changeTabs('backups')">
                                  Backups
                                  <span v-if="backupTasksFlag" class="badge badge-default rounded-circle noti-icon-badge ml-2">
                                   {{backupTasksFlag}}
                                  </span>
                                </a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" id="migration-tab" data-toggle="tab"  @click="changeTabs('migrations')"
                                 href="#migrationTasks" role="tab" aria-controls="down">
                                Migrations
                                <span class="badge badge-warning rounded-circle noti-icon-badge ml-2">{{activeSupportTasks.migrations}}</span>
                              </a>
                            </li>
                            <li class="nav-item">
                              <a class="nav-link" id="unique-tab" data-toggle="tab"  @click="changeTabs('uniqueVisits')"
                                 href="#uniqueTasks" role="tab" aria-controls="down">
                                Unique Visits
                                <span class="badge badge-warning rounded-circle noti-icon-badge ml-2">{{activeSupportTasks.unique}}</span>
                              </a>
                            </li>
                          <li class="nav-item">
                            <a class="nav-link" id="notInWpo-tab" data-toggle="tab"   @click="changeTabs('notInWpo')"
                               href="#notInWpo" role="tab" aria-controls="down">
                              CPanel
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link"  id="cPanelDomain-tab" data-toggle="tab"  href="#cPanelDomain" role="tab" aria-controls="up"  @click="changeTabs('others')">
                              Others
                            </a>

                          </li>

                          <li class="nav-item">
                                <a class="nav-link" id="resolved-tab" data-toggle="tab"  @click="changeTabs('resolved')"
                                   href="#resolveTasks" role="tab" aria-controls="down">
                                  Resolved
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="card-body" style="padding-top: 0 !important;">
                        <div class="tab-content customer-table">
                            <div id="activeTasks" class="tab-pane active show" v-if="currentTab === 'urgent'">
                               <template v-if="!parentLoading">
                              <TaskList @loadActivateCfModal="loadActivateCfModal" :tasks="urgentSupportTasks" type="active" tableId="activeSupportTasksTable" :parentLoader="parentLoading" />
                               </template>
                               <template v-else>
                                   <div class="loader"></div>
                               </template>
                            </div>
                            <div id="mediavineIntegration" class="tab-pane fade" v-if="currentTab === 'mvIntegration'">
                              <template v-if="!parentLoading">
                                <TaskList @loadActivateCfModal="loadActivateCfModal" :tasks="mvTasks" type="active" tableId="activeMVIntegrationTable" :parentLoader="parentLoading" />
                              </template>
                              <template v-else>
                                <div class="loader"></div>
                              </template>
                            </div>
                          <div id="backupTasks" class="tab-pane fade" v-if="currentTab === 'backups'">
                              <template v-if="!parentLoading">
                                <TaskList  :tasks="backUpSupportTasks" type="active" tableId="activeSupportTasksTableBackups" :parentLoader="parentLoading"   />
                              </template>
                              <template v-else>
                                <div class="loader"></div>
                              </template>
                            </div>
                            <div id="resolveTasks" class="tab-pane fade"  v-if="currentTab === 'resolved'">
                              <template v-if="!parentLoading">
                                <TaskList :tasks="resolvedSupportTasks" type="resolved" tableId="resolvedSupportTasksTable" :parentLoader="parentLoading"   @update:tasks="resolvedSupportTasks = $event" />
                              </template>
                              <template v-else>
                                <div class="loader"></div>
                              </template>
                            </div>
                             <div id="migrationTasks" class="tab-pane fade" v-if="currentTab === 'migrations'">
                               <template v-if="!parentLoading">
                                <TaskList :tasks="migrationSupportTasks" type="migration" tableId="activeSupportTasksTableMigrations" :parentLoader="parentLoading" />
                               </template>
                               <template v-else>
                                 <div class="loader"></div>
                               </template>
                            </div>
                             <div id="uniqueTasks" class="tab-pane fade" v-if="currentTab === 'uniqueVisits'">
                               <template v-if="!parentLoading">
                                <TaskList :tasks="uniqueVisitSupportTasks" type="uniqueVisitors" tableId="activeSupportTasksTableUniqueVisitors" :parentLoader="parentLoading" />
                               </template>
                               <template v-else>
                                 <div class="loader"></div>
                               </template>
                            </div>
                          <div id="notInWpo" class="tab-pane fade"  v-if="currentTab === 'notInWpo'">
                            <template v-if="!parentLoading">
                                <NotInWpo :tasks="notInWpoSupportTasks" type="notInWpo" tableId="activeSupportTasksTableNotInWpo" :parentLoader="parentLoading" />
                            </template>
                            <template v-else>
                              <div class="loader"></div>
                            </template>
                            </div>
                          <div id="cPanelDomain" class="tab-pane fade"  v-if="currentTab === 'others'">
                            <template v-if="!parentLoading">
                                <MissingCpanelDomainTaskList :tasks="otherSupportTasks" type="cPanelDomain" tableId="activeSupportTasksTableCPanelSupportTaskTable" :parentLoader="parentLoading" />
                            </template>
                            <template v-else>
                              <div class="loader"></div>
                            </template>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          <div class="col-md-12">
          <ManualTask task="Manual Tasks" type="support"/>
            <activate-c-f-modal ref="activeCfModal"/>
          </div>
        </div>
    </div>
</template>

<script>
    import {db} from "@/firebase/init";
    import ManualTask from "@/components/Admin/Sales/ManualTask.vue";
    import MissingCpanelDomainTaskList from "@/components/Admin/Tasks/missingCpanelDomainTaskList.vue";
    import supportTaskMixin from "@/mixins/supportTaskMixin";
    import _ from "lodash";
    import ActivateCFModal from "@/components/Admin/Tasks/activateCFModal.vue";

    export default {
        name: "TasksView",
        mixins: [supportTaskMixin],
        components: {
          ActivateCFModal,
          MissingCpanelDomainTaskList,
          ManualTask,
            TaskList: () => import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/TaskList.vue"),
            NotInWpo: () => import(/* webpackChunkName: "accDetailsUpdate" */ "../../../components/Admin/Tasks/notInWPO.vue"),
        },
        data () {
            return {
                currentTab: 'urgent',
                parentLoading: true,
                initTables: true,
                backupTasksFlag: 0,
                dataTables: ['activeSupportTasksTable', 'activeSupportTasksTableBackups', 'resolvedSupportTasksTable', 'activeSupportTasksTableMigrations', 'activeSupportTasksTableUniqueVisitors', 'activeSupportTasksTableNotInWpo']
            }
        },
        async mounted() {
            await this.fetchUrgentSupportTasksSnapShot()
            setTimeout(()=>{
            this.parentLoading = false
            }, 500)
            console.log('Data Fetched...');
            await this.checkBackupCount()
        },
        computed: {
          activeSupportTasks () {
            return this.$store.getters['tasks/getActiveSupportTasksCount'];
          },
        },
      watch: {
        notInWpoSupportTasks (value) {
          if(value){
            $(`#activeSupportTasksTableNotInWpo`).DataTable().destroy();
            setTimeout(()=>{
              this.initSupportTasksTable('activeSupportTasksTableNotInWpo')
            }, 500)
          }
        },
        urgentSupportTasks(value){
          if(value){
            $(`#activeSupportTasksTable`).DataTable().destroy();
            setTimeout(()=>{
              this.initSupportTasksTable('activeSupportTasksTable')
            }, 500)
          }
        },
        backUpSupportTasks(value){
          if(value){
            $(`#activeSupportTasksTableBackups`).DataTable().destroy();
            setTimeout(()=>{
              this.initSupportTasksTable('activeSupportTasksTableBackups')
            }, 500)
          }
        },
        migrationSupportTasks(value){
          if(value){
            $(`#activeSupportTasksTableMigrations`).DataTable().destroy();
            setTimeout(()=>{
              this.initSupportTasksTable('activeSupportTasksTableMigrations')
            }, 500)
          }
        }
        },
        methods: {
          loadActivateCfModal(data) {
            console.log('data')
            this.$refs.activeCfModal.load(data)
          },
          initSupportTasksTable(el) {
            console.log('Loading datatable');
            /* eslint-disable */
            $(`#${el}`).DataTable({
              pagingType: "full_numbers",
              lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
              destroy: true,
              retrieve: true,
              deferRender: true,
              "ordering": false,
              stateSave: true,
              language: {
                search: "_INPUT_",
                searchPlaceholder: "Search Task",
                size: 50
              }
            });
            /* eslint-enable */
          },
          async changeTabs(tabValue) {
            if (tabValue === this.currentTab) {
              return false;
            }
            this.currentTab = tabValue;
            await this.setTabs()
          },
          async setTabs(){
            this.reInitDataTable()
            switch (this.currentTab) {
              case 'urgent': {
                this.parentLoading = true
                await this.fetchUrgentSupportTasksSnapShot()
                this.destroyPreviousSnapShots(this.currentTab)
                setTimeout(()=>{
                  this.parentLoading = false
                }, 500)
                break;
              }
              case 'mvIntegration': {
                this.parentLoading = true
                await this.fetchMvIntegrationTaskSupport()
                this.destroyPreviousSnapShots(this.currentTab)
                setTimeout(()=>{
                  this.parentLoading = false
                }, 500)
                break;
              }
              case 'backups': {
                this.parentLoading = true
                await this.fetchBackUpSupportTasksSnapShot()
                this.destroyPreviousSnapShots(this.currentTab)
                setTimeout(()=>{
                  this.parentLoading = false
                }, 500)
                break;
              }
              case 'migrations': {
                this.parentLoading = true
                await this.fetchMigrationSupportTasksSnapShot()
                this.destroyPreviousSnapShots(this.currentTab)
                setTimeout(()=>{
                  this.parentLoading = false
                }, 500)
                break;
              }
              case 'uniqueVisits': {
                this.parentLoading = true
                await this.fetchUniqueVisitSupportTasksSnapShot()
                this.destroyPreviousSnapShots(this.currentTab)
                setTimeout(()=>{
                  this.parentLoading = false
                }, 500)
                break;
              }
              case 'others': {
                this.parentLoading = true
                await this.fetchMissingCpanelDomainSupportTasksSnapShot()
                this.destroyPreviousSnapShots(this.currentTab)
                setTimeout(()=>{
                  this.parentLoading = false
                }, 500)
                break;
              }
              case 'notInWpo': {
                this.parentLoading = true
                await this.fetchNotInWpoTaskSnapShot()
                this.destroyPreviousSnapShots(this.currentTab)
                setTimeout(()=>{
                  this.parentLoading = false
                }, 500)
                break;
              }
              case 'resolved': {
                this.parentLoading = true
                await this.fetchResolvedSupportTasks()
                this.destroyPreviousSnapShots('all')
                this.parentLoading = false
                break;
              }
              default: {
                console.log('Switched to another tab');
                break;
              }
            }
          },
          async checkBackupCount () {
            const ref = await db.collection('bigScootsTasks')
                .where('status', '==', 'pending')
                .where('type', '==', 'support')
                .where('text', '==', 'Backup Failure')
                .orderBy("createdAt", "desc").get();
            this.backupTasksFlag = ref.size
          },
          destroyPreviousSnapShots(ignoreSnapShot){
              const snapShots = {
                'urgent' : this.urgentSupportTaskListener,
                'mvIntegration' : this.mvListener,
                'migrations' : this.migrationSupportTaskListener ,
                'uniqueVisits' : this.uniqueSupportTaskListener,
                'others' : this.otherSupportTaskListener,
                'notInWpo' : this.notInWpoTaskListener,
                'backups' : this.backUpSupportTaskListener,
              };
              let snapShotKeys = Object.keys(snapShots);
              snapShotKeys = snapShotKeys.filter((value)=> value !== ignoreSnapShot);
              for (const snapShot of snapShotKeys){
                if(snapShots[snapShot]){
                  console.log('destroyed this one', snapShot)
                  snapShots[snapShot]()
                }
              }
          },
          reInitDataTable(){
                /* eslint-disable */
                this.dataTables.forEach(tableId => {
                    $(`#${tableId}`).DataTable().destroy();
                });
                /* eslint-enable */
            },
        },
        destroyed() {
            console.log('Detaching resolved support tasks listeners on admin side...');
            this.reInitDataTable()
            this.$store.dispatch('tasks/resetResolvedSupportListener');
            this.destroyPreviousSnapShots('all')
        }
    }
</script>

<style scoped>
    .nav-tabs .nav-item .nav-link.active:before,
    .nav-tabs .nav-item .nav-link.active:hover:before,
    .nav-tabs .nav-item .nav-link.active:focus:before {
        border: 0;
    }

    .nav-tabs {
        border-bottom: 1px solid #dee2e6;
    }

    .nav-tabs .nav-link {
        border: 1px solid transparent !important;
        border-top-left-radius: .25rem;
        border-top-right-radius: .25rem;
    }

    .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
        color: #495057;
        background-color: #fff;
        border-color: #dee2e6 #dee2e6 #fff !important;
    }

    .nav-tabs .nav-item .nav-link.active {
        color: #5B7CFB;
    }
</style>
